import {connect} from 'react-redux';

import {
    UserState,
    setUserAction,
    resetUserAction,
    editUserAction,
} from '@pluto/users';
import UserDetailsContainer from './UserDetailsContainer';
import {Notification} from '../../@pluto/notification';

export type UserDetailsState = {
        userDetails: UserState,
        notification: Notification,
}

export const mapState = (state: UserDetailsState): UserDetailsState => {
    const {
        userDetails,
        notification,
    } = state;
    
    return {
        userDetails,
        notification,
    };
};

export const mapDispatch = {
    setUser: setUserAction,
    resetUser: resetUserAction,
    editUser: editUserAction,
};

export default connect(mapState, mapDispatch)(UserDetailsContainer);
